import React, { FC } from 'react';

export const InterAppCloseIcon: FC = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.4375 8.5625L8.5625 1.4375M1.4375 1.4375L8.5625 8.5625"
      stroke="#292B3D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
